export function getYear() {
  const date = new Date();
  return date.getFullYear();
}

export function dateFormat(date) {
  const formattedDate = new Date(date);
  const day = formattedDate.getDate().toString().padStart(2, "0");
  const month = (formattedDate.getMonth() + 1).toString().padStart(2, "0");
  const year = formattedDate.getFullYear().toString();

  return `${day}-${month}-${year}`;
}
